import {Paper} from "@mui/material";
import ReactMarkdown from "react-markdown";
import StandardPage from "@/components/StandardPage.tsx";
import {useNotice} from "../components/Providers/NoticeProvider";

const Instructions = () => {
    const [notice] = useNotice();

    return (
        <StandardPage>
            <Paper elevation={3} sx={{p: 4, width: "100%"}}>
                <ReactMarkdown className="markdown">{notice.instructions}</ReactMarkdown>
            </Paper>
        </StandardPage>
    );
};

export default Instructions;
